import type { Participant } from "./ParticipantsGrid";

export interface OverflowTileItem {
  kind: "overflow";
  id: string;
  participants: Participant[];
}

export function isOverflowTileItem(item: Participant | OverflowTileItem): item is OverflowTileItem {
  return typeof (item as OverflowTileItem).kind === "string" && (item as OverflowTileItem).kind === "overflow";
}

export function buildOverflowItems(
  list: Participant[],
  maxVisible: number,
  overflowId: string,
  opts?: { alwaysIncludeLocal?: boolean }
): Array<Participant | OverflowTileItem> {
  if (maxVisible <= 0) {
    return list.length ? [{ kind: "overflow", id: overflowId, participants: list }] : [];
  }
  if (list.length <= maxVisible) return list;

  const visibleCount = Math.max(maxVisible - 1, 0);
  let visible = list.slice(0, visibleCount);
  const overflow = list.slice(visibleCount);

  if (opts?.alwaysIncludeLocal && visibleCount > 0 && !visible.some((p) => p.isLocal)) {
    const localIdx = overflow.findIndex((p) => p.isLocal);
    if (localIdx !== -1) {
      const [localParticipant] = overflow.splice(localIdx, 1);
      const displaced = visible.pop();
      if (displaced) overflow.unshift(displaced);
      visible = [...visible, localParticipant];
    }
  }

  return [
    ...visible,
    {
      kind: "overflow",
      id: overflowId,
      participants: overflow,
    },
  ];
}
